// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { isPrivileged } from "../utils/roles";

const PrivateRoute = ({ component: Component, adminOnly }) => {
  const { user, loading } = useAuth();

  if (loading) return <div style={{ padding: 16 }}>Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" />;

  if (adminOnly && !isPrivileged(user)) {
    return <Navigate to="/dashboard" />;
  }

  return <Component />;
};

export default PrivateRoute;
